import React from 'react'
import Modal from 'react-modal';

import CloseButton from "./CloseButton"

import './Info.scss';

Modal.setAppElement('#root')

class PoemInfo extends React.Component {
    constructor(props) {
        super(props)

        this.state = {isOpen: false}
        this.openInfo = this.openInfo.bind(this);
        this.closeInfo = this.closeInfo.bind(this);
    }

    openInfo() {
        this.setState({isOpen:true});
    }

    closeInfo() {
        this.setState({isOpen:false});
    }

    render() {
        return <>
            <button className="controlButton" disabled={this.props.info.description === ""} onClick={this.openInfo}>poem</button>
            <Modal
                isOpen={this.state.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeInfo}
                contentLabel="Info"
                className="Modal"
                overlayClassName="Overlay"
                closeTimeoutMS={500}
            >
                 <div className="info">
                    <button className="closeButton" onClick={this.closeInfo}><CloseButton /></button>
                    <h1>{this.props.info.title}</h1>
                    {(this.props.info.description === "" || this.props.info.description === undefined) ? <></> : this.props.info.description.split("\n").map(function(paragraph, index){
                        return <p key={index}>{paragraph}</p>;
                    })}
                </div>
            </Modal>
        </>;
    }
}

export default PoemInfo
